import React, { PureComponent } from "react";
import { UserDetailValues } from "@c/users-view/MainContent.styled";
import { ActionButton, PronunciationField } from "../../PronunciationView.styled";

class PronunciationCard extends PureComponent {
  handleEdit = () => {
    this.props.onEdit(this.props.entry);
  };

  handleDelete = e => {
    e.stopPropagation();
    this.props.onDelete(this.props.entry.id);
  };

  render() {
    const { entry } = this.props;
    return (
      <div style={{ padding: "0px 5px" }}>
        <UserDetailValues onClick={this.handleEdit}>
          <PronunciationField width="18%">{entry.word}</PronunciationField>
          <PronunciationField width="20%">{entry.respelling}</PronunciationField>
          <PronunciationField width="22%">
            {entry.voice || "All voices"}
          </PronunciationField>
          <PronunciationField width="25%">{entry.notes || "-"}</PronunciationField>
          <PronunciationField width="15%" align="center">
            <ActionButton onClick={this.handleEdit}>Edit</ActionButton>
            <ActionButton danger onClick={this.handleDelete}>
              Delete
            </ActionButton>
          </PronunciationField>
        </UserDetailValues>
      </div>
    );
  }
}

export default PronunciationCard;
